import {  Outlet, RouteObject } from "react-router-dom";


import LicenceApplicationDetails from "./fragments/licence-application-details";
import LicencesApplications from "./licences-applications";


const routes: RouteObject = {
    path: "licences",
    element: <Outlet />,
    children: [
        {
            index: true,
            element: <LicencesApplications />
        },
        {
            path: "",
            element: <LicencesApplications />,
            children: [
                {
                    path: ":applicationId",
                    element: <LicenceApplicationDetails />
                }
            ]
        },
    ]
}

export default routes


